import { render, staticRenderFns } from "./DeleteBulkGroup.vue?vue&type=template&id=66ffb54e&"
import script from "./DeleteBulkGroup.vue?vue&type=script&lang=js&"
export * from "./DeleteBulkGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports